export const categories = [
  {
    id: "shoes",
    namePl: "Buty",
    nameEn: "Shoes",
    url: "https://kaspreadsheet.com/category-911-Shoes.html",
    icon: "ri-footprint-line",
    imageUrl: "https://readdy.ai/api/search-image?query=Stylish%20trendy%20sneakers%20collection%20displayed%20on%20a%20clean%20minimalist%20white%20shelf%2C%20soft%20natural%20lighting%20from%20large%20window%2C%20modern%20Scandinavian%20interior%20aesthetic%2C%20warm%20beige%20and%20cream%20tones%2C%20product%20photography%20style%20with%20shallow%20depth%20of%20field%2C%20elegant%20composition%20with%20negative%20space&width=400&height=400&seq=cat-shoes-v3&orientation=squarish"
  },
  {
    id: "hoodies",
    namePl: "Bluzy/Swetry",
    nameEn: "Hoodies/Sweaters",
    url: "https://kaspreadsheet.com/search-912/name/Shoes.html",
    icon: "ri-t-shirt-line",
    imageUrl: "https://readdy.ai/api/search-image?query=Cozy%20oversized%20hoodie%20and%20sweater%20neatly%20folded%20on%20a%20light%20wooden%20surface%2C%20warm%20ambient%20lighting%2C%20soft%20neutral%20oatmeal%20and%20cream%20color%20palette%2C%20minimalist%20Scandinavian%20style%20flat%20lay%2C%20visible%20textile%20texture%2C%20clean%20aesthetic%20product%20photography&width=400&height=400&seq=cat-hoodies-v3&orientation=squarish"
  },
  {
    id: "tshirts",
    namePl: "Koszulki",
    nameEn: "T-Shirts",
    url: "https://kaspreadsheet.com/search-913/name/Shoes.html",
    icon: "ri-t-shirt-line",
    imageUrl: "https://readdy.ai/api/search-image?query=Premium%20white%20and%20pastel%20t-shirts%20elegantly%20displayed%20on%20wooden%20hangers%20against%20a%20soft%20cream%20textured%20wall%2C%20natural%20daylight%20illuminating%20fabric%20texture%2C%20minimalist%20boutique%20aesthetic%2C%20warm%20earthy%20sand%20tones%2C%20clean%20editorial%20fashion%20photography&width=400&height=400&seq=cat-tshirts-v3&orientation=squarish"
  },
  {
    id: "jackets",
    namePl: "Kurtki",
    nameEn: "Jackets",
    url: "https://kaspreadsheet.com/search-914/name/Shoes.html",
    icon: "ri-shirt-line",
    imageUrl: "https://readdy.ai/api/search-image?query=Stylish%20bomber%20jacket%20and%20denim%20jacket%20hung%20on%20a%20minimalist%20clothing%20rack%2C%20soft%20natural%20side%20light%2C%20modern%20loft%20interior%20with%20white%20brick%20walls%2C%20warm%20neutral%20taupe%20and%20cream%20palette%2C%20editorial%20fashion%20photography%20with%20clean%20composition&width=400&height=400&seq=cat-jackets-v3&orientation=squarish"
  },
  {
    id: "pants",
    namePl: "Spodnie/Szorty",
    nameEn: "Pants/Shorts",
    url: "https://kaspreadsheet.com/search-915/name/Shoes.html",
    icon: "ri-pantone-line",
    imageUrl: "https://readdy.ai/api/search-image?query=Well%20folded%20casual%20chinos%20and%20tailored%20shorts%20stacked%20neatly%20on%20a%20light%20oak%20shelf%2C%20soft%20morning%20sunlight%20creating%20gentle%20shadows%2C%20minimalist%20clothing%20display%2C%20warm%20cream%20and%20sand%20background%2C%20textile%20textures%20visible%2C%20clean%20product%20photography&width=400&height=400&seq=cat-pants-v3&orientation=squarish"
  },
  {
    id: "headwear",
    namePl: "Nakrycia głowy",
    nameEn: "Headwear",
    url: "https://kaspreadsheet.com/search-916/name/Shoes.html",
    icon: "ri-glasses-line",
    imageUrl: "https://readdy.ai/api/search-image?query=Various%20stylish%20caps%20and%20beanies%20arranged%20on%20a%20minimalist%20wooden%20display%20stand%2C%20soft%20diffused%20natural%20light%2C%20clean%20cream%20background%2C%20modern%20accessories%20boutique%20aesthetic%2C%20warm%20neutral%20mushroom%20tones%2C%20editorial%20product%20photography&width=400&height=400&seq=cat-headwear-v3&orientation=squarish"
  },
  {
    id: "sets",
    namePl: "Zestawy",
    nameEn: "Sets",
    url: "https://kaspreadsheet.com/search-917/name/Shoes.html",
    icon: "ri-stack-line",
    imageUrl: "https://readdy.ai/api/search-image?query=Color%20coordinated%20matching%20clothing%20outfit%20set%20displayed%20flat%20on%20a%20clean%20minimalist%20linen%20background%2C%20soft%20studio%20lighting%2C%20warm%20cream%20and%20terracotta%20aesthetic%2C%20fashion%20editorial%20style%2C%20clean%20composition%20with%20ample%20space&width=400&height=400&seq=cat-sets-v3&orientation=squarish"
  },
  {
    id: "underwear",
    namePl: "Bielizna",
    nameEn: "Underwear/Underpants",
    url: "https://kaspreadsheet.com/search-918/name/Shoes.html",
    icon: "ri-shirt-line",
    imageUrl: "https://readdy.ai/api/search-image?query=Premium%20cotton%20underwear%20neatly%20folded%20and%20displayed%20on%20a%20soft%20linen%20fabric%20surface%2C%20gentle%20natural%20morning%20lighting%2C%20minimalist%20boutique%20aesthetic%2C%20warm%20cream%20and%20blush%20rose%20tones%2C%20clean%20product%20photography%20with%20soft%20shadows&width=400&height=400&seq=cat-underwear-v3&orientation=squarish"
  },
  {
    id: "jersey",
    namePl: "Koszulki sportowe",
    nameEn: "Jersey",
    url: "https://kaspreadsheet.com/search-919/name/Shoes.html",
    icon: "ri-football-line",
    imageUrl: "https://readdy.ai/api/search-image?query=Sports%20jerseys%20with%20bold%20graphics%20displayed%20on%20minimalist%20hangers%20against%20a%20clean%20light%20wall%2C%20natural%20daylight%2C%20modern%20sports%20apparel%20store%20aesthetic%2C%20warm%20neutral%20background%20with%20subtle%20texture%2C%20editorial%20product%20photography&width=400&height=400&seq=cat-jersey-v3&orientation=squarish"
  },
  {
    id: "accessories",
    namePl: "Akcesoria",
    nameEn: "Accessories",
    url: "https://kaspreadsheet.com/search-920/name/Shoes.html",
    icon: "ri-bank-card-line",
    imageUrl: "https://readdy.ai/api/search-image?query=Various%20trendy%20fashion%20accessories%20including%20wristwatch%20and%20bracelet%20elegantly%20arranged%20on%20a%20smooth%20concrete%20surface%2C%20soft%20natural%20lighting%2C%20luxury%20minimalist%20aesthetic%2C%20warm%20cream%20and%20champagne%20tones%2C%20editorial%20product%20photography&width=400&height=400&seq=cat-accessories-v3&orientation=squarish"
  },
  {
    id: "bags",
    namePl: "Torby",
    nameEn: "Bags",
    url: "https://kaspreadsheet.com/search-921/name/Shoes.html",
    icon: "ri-briefcase-line",
    imageUrl: "https://readdy.ai/api/search-image?query=Stylish%20minimalist%20backpack%20and%20tote%20bag%20displayed%20on%20a%20sleek%20wooden%20shelf%2C%20soft%20natural%20light%20from%20window%2C%20modern%20accessories%20boutique%20interior%2C%20warm%20cream%20and%20cognac%20leather%20tones%2C%20clean%20product%20photography%20with%20elegant%20spacing&width=400&height=400&seq=cat-bags-v3&orientation=squarish"
  },
  {
    id: "belts",
    namePl: "Paski",
    nameEn: "Belts",
    url: "https://kaspreadsheet.com/search-922/name/Shoes.html",
    icon: "ri-links-line",
    imageUrl: "https://readdy.ai/api/search-image?query=Premium%20leather%20belts%20elegantly%20coiled%20and%20displayed%20on%20a%20minimalist%20white%20surface%2C%20soft%20studio%20lighting%2C%20warm%20caramel%20brown%20and%20cream%20tones%2C%20luxury%20accessories%20photography%2C%20clean%20composition%20showing%20leather%20texture%20and%20metallic%20buckle%20details&width=400&height=400&seq=cat-belts-v3&orientation=squarish"
  },
  {
    id: "perfumes",
    namePl: "Perfumy",
    nameEn: "Perfumes",
    url: "https://kaspreadsheet.com/search-923/name/Shoes.html",
    icon: "ri-drop-line",
    imageUrl: "https://readdy.ai/api/search-image?query=Elegant%20glass%20perfume%20bottles%20arranged%20on%20a%20white%20marble%20surface%2C%20soft%20natural%20lighting%20creating%20gentle%20reflections%20on%20glass%2C%20minimalist%20luxury%20beauty%20aesthetic%2C%20warm%20cream%20and%20soft%20blush%20pink%20tones%2C%20editorial%20beauty%20product%20photography&width=400&height=400&seq=cat-perfumes-v3&orientation=squarish"
  },
  {
    id: "other",
    namePl: "Inne produkty",
    nameEn: "Other Stuff",
    url: "https://kaspreadsheet.com/search-924/name/Shoes.html",
    icon: "ri-more-line",
    imageUrl: "https://readdy.ai/api/search-image?query=Miscellaneous%20lifestyle%20products%20including%20small%20accessories%20and%20gadgets%20displayed%20on%20a%20clean%20minimalist%20surface%2C%20soft%20natural%20lighting%2C%20warm%20cream%20background%2C%20modern%20lifestyle%20product%20photography%2C%20organized%20arrangement%20with%20clean%20composition&width=400&height=400&seq=cat-other-v3&orientation=squarish"
  }
];

export const mainSiteUrl = "https://kaspreadsheet.com";